import { Menu, ALIGNMENT } from 'ui/menu';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { useCampaignStateOptions } from '../hooks/useCampaignStateOptions';

export const content = {
  title: 'Filters',
};

type Props = {
  selectedFilters: any;
  [otherOptions: string]: any;
};

export const UsageFilterMenu = ({ onSelect, selectedFilters = [] }: Props) => {
  const [campaignStates] = useCampaignStateOptions();

  // combine into array for other transformations
  const options = campaignStates.map((status) => {
    return {
      isSelectMenu: true,
      label: status,
      id: status,
      prefix: `${status.toLowerCase()}-`,
      queryLabel: 'name',
      queryId: 'name',
    };
  });

  options.push({
    isSelectMenu: true,
    label: 'Inactive',
    id: 'Inactive',
    prefix: `invactive-`,
    queryLabel: 'name',
    queryId: 'name',
  });

  const handleSelect = (selectedId: string) => {
    const filterSet = new Set(selectedFilters);

    if (filterSet.has(selectedId)) {
      filterSet.delete(selectedId);
    } else {
      filterSet.add(selectedId);
    }

    onSelect(Array.from(filterSet));
  };

  return (
    <Menu
      isSelectMenu={true}
      defaultSelectedOptionIds={selectedFilters}
      options={options}
      handleSelectionChange={handleSelect}
      horizontalAlignment={ALIGNMENT.RIGHT}
    >
      <FilterMenuTriggerButton selectedFilterCount={selectedFilters.length} />
    </Menu>
  );
};
